import React, { useEffect, useState } from 'react';
import { Components } from 'versafleet-core';
import Footer from 'modules/footer';
import { useVerifyContactNumber } from 'queryActions/useTasksRescheduling';
import { useGetOrderDetails } from 'queryActions/useOrderDetails';
import { useLocation, useNavigate } from 'react-router-dom';

function ContactVerification() {
  const [lastDigits, setLastDigits] = useState('');
  const [showWarningModal, setShowWarningModal] = useState(false);

  const { orderDetails } = useGetOrderDetails();
  const {
    verifyContactNumber,
    isLoadingVerifyContactNumber,
    isVerified,
    errorVerifyContactNumber,
  } = useVerifyContactNumber();

  const navigate = useNavigate();
  const location = useLocation();

  const isValidForm = lastDigits.length === 4;

  useEffect(() => {
    if (errorVerifyContactNumber) {
      setShowWarningModal(true);
    }
  }, [errorVerifyContactNumber]);

  useEffect(() => {
    if (!location.state?.fromDetailPage) {
      navigate(-1);
    }
  }, [navigate, location.state]);

  useEffect(() => {
    if (isVerified) {
      navigate('../reschedule', {
        relative: 'path',
        state: { fromVerifyPage: isVerified },
        replace: true,
      });
    }
  }, [navigate, isVerified]);

  return (
    <div className="vf-tracking">
      <Components.Container
        className="vf-tracking__detail-container"
      >
        <Components.Window.Section.Heading>
          Verify Your Identity
        </Components.Window.Section.Heading>

        <Components.Window.Section>
          <Components.Window.FieldEdit.Textbox
            digitLimit={4}
            fieldName="Your Contact Number"
            isRequired
            min={0}
            onChange={setLastDigits}
            placeholder="Last 4 digits"
            type="number"
            value={lastDigits}
          />

          <Components.Window.Subsection>
            <Components.Window.Description>
              Input the last 4 digits of your contact number.
              <br />
              Note: This should be the contact number used when the order is placed.
            </Components.Window.Description>
          </Components.Window.Subsection>
        </Components.Window.Section>

        <Components.Button
          className="vf-rescheduling__verify-button"
          disabled={!isValidForm}
          fillColor
          loading={isLoadingVerifyContactNumber}
          onClick={() => verifyContactNumber(lastDigits)}
        >
          Verify
        </Components.Button>

        <Components.Modal.Warning
          headerText="The last 4 digits of the contact number cannot be verified"
          rightButtonOnClick={() => setShowWarningModal(false)}
          rightButtonText="Try Again"
          visible={showWarningModal}
        >
          <Components.Window.Description>
            Please check your order details again to confirm the contact number before trying again.
            <br />
            <br />
            {`Alternatively, please contact ${orderDetails?.account.name || 'the Company'} for assistance.`}
          </Components.Window.Description>
        </Components.Modal.Warning>
      </Components.Container>

      <Footer />
    </div>
  );
}

export default ContactVerification;
